import {useDispatch} from "react-redux";
import type {Dispatch} from "redux";

import {appendQueryString, IQuery} from "@pg-mono/request";
import {apiUserLink} from "@pg-mono/rp-api-routes";
import {rpAppPath} from "@pg-mono/rp-routes";
import {createLinkWithCrossSiteTracking} from "@pg-rp/navigation";

import {emptyLeadStorageData} from "../../application/constants/lead/empty_lead_storage_data";
import {ISentLeadActions, setSentLeadValuesAction} from "../../application/reducers/sent_lead_reducer";
import {removeArticleAttachmentLSStore} from "../../article/hooks/use_article_attachment_ls_store";

export const useRedirectedAuth = () => {
    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const onRedirectedLogin = (redirectUriQuery: IQuery = {}) => {
        const query: IQuery = {
            redirect_uri: appendQueryString(`${location.origin}${rpAppPath.oauth.redirect}`, redirectUriQuery)
        };

        window.location.href = createLinkWithCrossSiteTracking(apiUserLink.oauth.authorize, query);
    };

    const onRedirectedLogout = () => {
        removeArticleAttachmentLSStore();
        dispatch<ISentLeadActions>(setSentLeadValuesAction(emptyLeadStorageData));
        window.location.href = appendQueryString(apiUserLink.users.logout, {
            next: `${location.origin}${location.pathname}`
        });
    };

    return {
        onRedirectedLogin,
        onRedirectedLogout
    };
};
import {useDispatch} from "react-redux";
import type {Dispatch} from "redux";

import {appendQueryString, IQuery} from "@pg-mono/request";
import {apiUserLink} from "@pg-mono/rp-api-routes";
import {rpAppPath} from "@pg-mono/rp-routes";
import {createLinkWithCrossSiteTracking} from "@pg-rp/navigation";

import {emptyLeadStorageData} from "../../application/constants/lead/empty_lead_storage_data";
import {ISentLeadActions, setSentLeadValuesAction} from "../../application/reducers/sent_lead_reducer";
import {removeArticleAttachmentLSStore} from "../../article/hooks/use_article_attachment_ls_store";

export const useRedirectedAuth = () => {
    const dispatch: Dispatch<ISentLeadActions> = useDispatch();

    const onRedirectedLogin = (redirectUriQuery: IQuery = {}) => {
        const query: IQuery = {
            redirect_uri: appendQueryString(`${location.origin}${rpAppPath.oauth.redirect}`, redirectUriQuery)
        };

        window.location.href = createLinkWithCrossSiteTracking(apiUserLink.oauth.authorize, query);
    };

    const onRedirectedLogout = () => {
        removeArticleAttachmentLSStore();
        dispatch<ISentLeadActions>(setSentLeadValuesAction(emptyLeadStorageData));
        window.location.href = appendQueryString(apiUserLink.users.logout, {
            next: `${location.origin}${location.pathname}`
        });
    };

    return {
        onRedirectedLogin,
        onRedirectedLogout
    };
};
